module.exports = __webpack_public_path__ + "img/logo.1452ff85.png";